module.exports = __webpack_public_path__ + "img/cover_photo.2495e13c.jpg";